import { Component, effect, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { TranslateService, Translation } from '@ngx-translate/core';
import { telekomPassthrough } from '../passthrough/telekom-passthrough';
import { PrimeNG } from 'primeng/config';
import { LanguageService } from '@core/services/language.service';
import { Navbar } from './shared/components/navbar/navbar.component';
import { BannerComponent } from './shared/components/banner/banner.component';
import { ErrorDialogComponent } from './shared/components/error-dialog/error-dialog.component';
import { BannerApiService } from '@core/services/banner-api.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navbar, BannerComponent, ErrorDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  public translate = inject(TranslateService);
  public primeng = inject(PrimeNG);
  private langService = inject(LanguageService);
  private bannerApiService = inject(BannerApiService);
  private router = inject(Router);

  protected isFullWidth = toSignal(
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map(() => {
        let route = this.router.routerState.snapshot.root;
        while (route.firstChild) route = route.firstChild;
        return !!route.data['fullWidth'];
      }),
      startWith(false),
    ),
  );

  constructor() {
    effect(() => {
      this.langService.currentLang();
      this.translate.get(['HOME', 'PRIMENG']).subscribe((tsKeys: Record<string, Translation>) => {
        this.primeng.setTranslation(tsKeys['PRIMENG']);
        this.primeng.pt.set(telekomPassthrough(tsKeys));
      });
    });
    this.bannerApiService.init();
  }
}
